<div class="lg-panel-switch__header">
    <h2>{{ title }}</h2>
    <div class="lg-panel-switch__header__icons">
        @if (_leftAdditionalItems$ | async; as leftItems) {
            @for (item of leftItems; track item) {
                <ng-container *ngTemplateOutlet="item"></ng-container>
            }
        }
        <lg-icon-menu
            [definition]="_dropdownDefinition"
            [current]="(_currentChoice$ | async)?.id"
            (currentChange)="_choiceChange($event)"
            [icon]="(_currentChoice$ | async)?.icon"
            class="lg-panel__header-icon"
            [tooltip]="'FW._Directives._lgPanelSwitch.SelectView' | lgTranslate"
        >
        </lg-icon-menu>
        @if (_rightAdditionalItems$ | async; as rightItems) {
            @for (item of rightItems; track item) {
                <ng-container *ngTemplateOutlet="item"></ng-container>
            }
        }
    </div>
</div>
<div class="lg-panel-switch__body">
    <ng-container
        *ngTemplateOutlet="_getPanelTemplate(); context: { $implicit: _state$ }"
    ></ng-container>
</div>
